import $ from 'jquery';

$(() => {
    $(document.links).filter(function() {
      const parts = this.href.split(":");
      let isMail = false;
      if (parts.length >= 2 && parts[0] == "mailto" && parts[0] == "tel") {
        isMail = true;
      }
      const protocol = window.location.protocol;
      const isExternal = this.hostname != 'em-immo.at' &&  this.hostname != 'www.em-immo.at';
      return !isMail && isExternal;
    }).attr('target', '_blank');
});


